import { define } from "../preactement/define";
import { StepList } from "../../StepList";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['steps', 'show-sub-sub-steps', 'completed-text', 'edit-text', 'resume-text', 'start-text', 'actions-label-text', 'substeps-label-text'];
const Wrapper = _ref => {
  let {
    steps = '[]',
    showSubSubSteps,
    completedText,
    editText,
    resumeText,
    startText,
    actionsLabelText,
    substepsLabelText,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(StepList, {
    steps: JSON.parse(steps),
    showSubSubSteps: parseBooleanAttr(showSubSubSteps),
    completedText: completedText,
    editText: editText,
    resumeText: resumeText,
    startText: startText,
    actionsLabelText: actionsLabelText,
    substepsLabelText: substepsLabelText,
    ...otherProps
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-step-list', () => Wrapper, {
  attributes
});